import { NgxUiLoaderConfig } from "ngx-ui-loader";

export const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  fgsType: 'three-strings',
  fgsColor: '#00ACC1',
  overlayColor: 'rgba(40,40,40,0.8)',
  hasProgressBar: false
};